import { Button, Card } from 'antd';
import styled from 'styled-components';

export const RegistrationCard = styled(Card)`
  width: 636px;
`;

export const SubmitButton = styled(Button)`
  width: 284px;
`;
